<template>
  <div>
    <div>
      <div class="account-block">
        <span class="account__subtitle">{{ $t(`account.edit.companyName`) }}</span>
        <span class="account__text">{{ clientData.displayName || clientData.name }}</span>
      </div>
      <div class="account-block">
        <span class="account__subtitle">{{ $t('nouns.CID') }}</span>
        <span class="account__text">{{ clientData.cid }}</span>
      </div>
      <div v-profile-guard="'components.dataAccount.edit.editAccount'" class="account__link">
        <a @click="openPopUp = true">{{ $t('actions.editDates') }}</a>
      </div>
    </div>
    <PopUpCompany
      v-if="openPopUp"
      :client-data="clientData"
      @update-client="(data) => $emit('update-client', data)"
      @close="openPopUp = $event"
    ></PopUpCompany>
  </div>
</template>

<script>
import PopUpCompany from '../PopUps/PopUpCompany';

export default {
  name: 'FormCompany',
  components: {
    PopUpCompany
  },
  props: {
    clientData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      openPopUp: false
    };
  },
  methods: {
    fieldToEdit(event) {
      this.$emit('fieldToEdit', event);
    }
  }
};
</script>
